/* Change this file to get your personal Portfolio */

// Summary And Greeting Section
import emoji from "react-easy-emoji";

const illustration = {
  animated: true, // set to false to use static SVG
};

const greeting = {
  username: "Rigers Leka",
  title: "Hi all, I'm Rigers",
  subTitle: emoji(
    "A passionate FrontEnd Software Developer 🚀 having an experience of designing and building Web application with Javascript / Angular / React and some other cool libraries and frameworks."
  ),
  resumeLink:
    //Upload CV on your drive
    "https://drive.google.com/file/d/1DI0Cx6LsRRtNZszt6KYFzoUg_TjZtjW6/view?usp=drive_link",
  displayGreeting: true, // Set false to hide this section, defaults to true
};

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/rigersleka",
  linkedin: "https://www.linkedin.com/in/rigers-leka/",
  gmail: "rigers.leka@yahoo.com",
  gitlab: "https://gitlab.com/rigers-leka",
  // facebook: "https://www.facebook.com/",
  // medium: "https://medium.com/@davidrakosi",
  stackoverflow: "https://stackoverflow.com/users/15415819/rigers-leka",
  // instagram: 'https://www.instagram.com/davidrakosi/',
  // twitter: 'https://twitter.com/davidrakosi_',
  display: true, // Set true to display this section, defaults to false
};

// Skills Section
const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FRONTEND DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) and SPA Stacks in normal"),
    emoji("⚡ Integration of third party services such as Firebase"),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */
  softwareSkills: [
    {
      skillName: "react",
      fontAwesomeClassname: "fab fa-react",
    },
    {
      skillName: "angular",
      fontAwesomeClassname: "fab fa-angular",
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5",
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt",
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass",
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js",
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fa-brands fa-github",
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm",
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database",
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire",
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Education Section
const educationInfo = {
  schools: [
    {
      schoolName: "University Polytechnic of Tirana",
      logo: require("./assets/images/polytechnicLogo.png"),
      subHeader: "Master of Science in Computer Engineering",
      duration: "September 2016 - April 2018",
      desc: "Graduated in Computer Engineering with good grades.",
      descBullets: [
        "Web Development",
        "Object-Oriented Programming With Java",
        "Computer Hardware 2",
        "Operating Systems 2",
      ],
    },
    {
      schoolName: "University Polytechnic of Tirana",
      logo: require("./assets/images/polytechnicLogo.png"),
      subHeader: "Bachelor of Science in Computer Engineering",
      duration: "September 2013 - April 2016",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: [
        "Data structures and algorithms with C",
        "Databases",
        "Computer Hardware",
        "Operating Systems",
        "Electronic Circuits and Logic Design Laboratory.",
      ],
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Your top 3 proficient stacks/tech experience
const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Angular", //Insert stack or technology you have experience in
      progressPercentage: "89%", //Insert relative proficiency in percentage
    },
    {
      Stack: "React",
      progressPercentage: "90%",
    },
    {
      Stack: "Redux / Rxjs",
      progressPercentage: "75%",
    },
    {
      Stack: "Cypress",
      progressPercentage: "54%",
    },
    {
      Stack: "Bootstrap / Material-Ui / Style Components",
      progressPercentage: "72%",
    },
    {
      Stack: "Ag-Grid / highcharts",
      progressPercentage: "65%",
    },
  ],
  displayCodersrank: true, // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section
const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Frontend Developer",
      company: "Ortec Finance",
      companylogo: require("./assets/images/ortecFinance.png"),
      date: "January 2023 – Present",
      desc: "My core activities:",
      descBullets: [
        "Building app using Angular 16",
        "Maintain state using RxJs",
        "Automation-testing with Cypress",
      ],
    },
    {
      role: "Frontend Developer",
      company: "Sisal",
      companylogo: require("./assets/images/sisal.png"),
      date: "November 2020 – December 2022",
      desc: "My core activities:",
      descBullets: [
        "Develop applications with React",
        "Modular, responsive websites",
        "Intuitive user interface",
      ],
    },
    {
      role: "Frontend Developer",
      company: "Pleaseup",
      companylogo: require("./assets/images/pleaseUp.png"),
      date: "July 2028 – July 2019",
      desc: "Key qualifications and responsibilities as part of a small team of developers.",
      descBullets: [
        "Maintain Websites",
        "Manual Testing",
        "Document new stories/bugs",
      ],
    },
    {
      role: "Frontend Developer",
      company: "Links Management & Technology",
      companylogo: require("./assets/images/linksManagement.png"),
      date: "September 2019 – October 2020",
      desc: "My core activities",
      descBullets: [
        "UI for pixel-perfect",
        "Translated client requirements into application design",
        "Collaborate with backend developers",
      ],
    },
    {
      role: "Software Developer",
      company: "Co.M.Media",
      companylogo: require("./assets/images/commediaLogo.png"),
      date: "July 2017 – August 2018",
      desc: "Key qualifications and responsibilities:",
      descBullets: [
        "Maintain Websites",
        "Manual Testing",
        "Document new stories/bugs",
      ],
    },
    {
      role: "IT Consulant",
      company: "Pelikan Security",
      companylogo: require("./assets/images/pelikanSecurityLogo.png"),
      date: "February 2016 – April 2017",
      desc: "Maintain and improve of existing company network, servers.",
      descBullets: [
        "Maintain company's network",
        "Troubleshooting PC's hardware faults",
        "Configure security camera",
      ],
    },
  ],
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */
const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "rigersleka", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false, // Set false to hide this section, defaults to true
};

// Some big projects you have worked on
const bigProjects = {
  title: "Big Projects",
  subtitle: "MY CONTRIBUTIONS TO COMPANIES FOR CREATING THEIR TECH",
  projects: [
    {
      image: require("./assets/images/glassLogo.png"),
      projectName: "GLASS FLOW / FLEX",
      projectDesc:
        "Under Development...",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.ortecfinance.com/en/insights/product/glass-flow",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/areaRiservata.png"),
      projectName: "Area Riservata",
      projectDesc:
        "To make an account and log in to the online games Sisal offers, the player must complete a number of steps.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://areaprivata.sisal.it/registrazioneJwt/seleziona-registrazione",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/millipiyango.png"),
      projectName: "Millipiyango",
      projectDesc:
        "In addition to the main lottery, national turkish lottery game Milli Piyango offers visitors numerous ways to try their luck ",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.millipiyangoonline.com/",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/projectQuidLogo.png"),
      projectName: "Quid",
      projectDesc:
        "Focused on business tools, expert support and much more for companies and individuals.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://quidglobal.com/",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/projectBancaGeneraliLogo.png"),
      projectName: "Banca Generali",
      projectDesc:
        "Plan your fiscal and tax deadlines and independently arrange online payments. Internal app to be used from users. ",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.bancageneraliprivate.it/homepage",
        },
      ],
    },
    // {
    //   image: require("./assets/images/projectJaguarLogo.png"),
    //   projectName: "Jaguar & Landrover with FcaBank",
    //   projectDesc: "Monthly car payment",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "https://www.jaguarnewportbeach.com/payment-calculator/",
    //     },
    //   ],
    // },
    {
      image: require("./assets/images/fcaWithAmazon.png"),
      projectName: "FCA and Leasys Bank with Amazon",
      projectDesc:
        "Possibility to rent cars. Integrate Amazon Login Button, implement multiple steps, where create ability to rent a car.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://adnews.galitt.com/en/articles/details/leasys-and-fca-bank-try-short-term-leasing-via-amazon",
        },
      ],
    },
    {
      image: require("./assets/images/comingsoon.jpg"),
      projectName: "Internal Links Selection Systems",
      projectDesc:
        "System that helps companies filtering applicants more easily.",
      footerLink: [
        {
          name: "Visit Website",
          url: "",
        },
      ],
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc
const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "",
        },
        {
          name: "Award Letter",
          url: "",
        },
        {
          name: "Google Code-in Blog",
          url: "",
        },
      ],
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/polytechnicLogo.png"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "",
        },
      ],
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: "",
        },
      ],
    },
  ],
  display: false, // Set false to hide this section, defaults to true
};

// Talks Sections
const talkSection = {
  title: "TALKS",
  subtitle: emoji(""),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: "",
    },
  ],
  display: false, // Set false to hide this section, defaults to true
};

// Podcast Section
const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [""],
  display: false, // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "(+31) 629801067",
  email_address: "rigers.leka@yahoo.com",
};

// Twitter Section
const twitterDetails = {
  userName: "RigersLeka2",
  display: true, // Set true to display this section, defaults to false
};

export {
  achievementSection,
  bigProjects,
  contactInfo,
  educationInfo,
  greeting,
  illustration,
  openSource,
  podcastSection,
  skillsSection,
  socialMediaLinks,
  talkSection,
  techStack,
  twitterDetails,
  workExperiences
};

